export const INVENTORY_ITEMS_HISTORY_REPORT = "inventory-items-history";
export const INVENTORY_ITEMS_NO_MOVEMENT_30_DAYS_REPORT =
  "inventory-items-no-movement-30-days";
export const INVENTORY_ITEMS_NEVER_MOVED_REPORT =
  "inventory-items-history-no-movement";
export const INVENTORY_ITEMS_STOCK_VS_DRAFT_REPORT =
  "inventory-items-stock-vs-draft";

export const WAREHOUSE_CANNED_REPORTS = [
  {
    key: INVENTORY_ITEMS_HISTORY_REPORT,
    slug: INVENTORY_ITEMS_HISTORY_REPORT,
    title: "Inventory Item Activity",
    description: "Review detailed breakdown of warehouse item activity.",
    distributionReportName: "warehouse canned report - inventory-items-history",
    supportsChart: true,
    supportsSortOrder: false,
    // tableTitle: "Inventory Movement Results",
    rowLabel: "Item",
    emptyText: "No inventory item history found.",
  },
  {
    key: INVENTORY_ITEMS_NO_MOVEMENT_30_DAYS_REPORT,
    slug: INVENTORY_ITEMS_NO_MOVEMENT_30_DAYS_REPORT,
    title: "Aging Inventory Report",
    description:
      "Materials sitting in the warehouse for more than 30 days. Great for spotting dead stock tying up space and capital.",
    distributionReportName:
      "warehouse canned report - inventory-items-no-movement-30-days",
    supportsChart: false,
    supportsSortOrder: false,
    // tableTitle: "Items With No Movement in 30 Days",
    rowLabel: "Item",
    emptyText: "No inventory items with no movement in 30 days found.",
  },
  {
    key: INVENTORY_ITEMS_NEVER_MOVED_REPORT,
    slug: INVENTORY_ITEMS_NEVER_MOVED_REPORT,
    title: "Inventory Items With No Activity",
    description:
      "Materials sitting in the warehouse with no activity. Great for spotting dead stock tying up space and capital.",
    distributionReportName:
      "warehouse canned report - inventory-items-history-no-movement",
    supportsChart: false,
    supportsSortOrder: false,
    // tableTitle: "Inventory Items Never Moved",
    rowLabel: "Item",
    emptyText: "No inventory items with no movement history found.",
  },
  {
    key: INVENTORY_ITEMS_STOCK_VS_DRAFT_REPORT,
    slug: INVENTORY_ITEMS_STOCK_VS_DRAFT_REPORT,
    title: "Allocated VS Unallocated Stock",
    description:
      "Items reserved for specific projects vs free stock, so PMs don't double-promise the same material.",
    distributionReportName:
      "warehouse canned report - inventory-items-stock-vs-draft",
    supportsChart: false,
    supportsSortOrder: false,
    // tableTitle: "Inventory Stock vs Transfer Drafts",
    rowLabel: "Item",
    emptyText: "No inventory items with transfer draft stock data found.",
  },
];

export const WAREHOUSE_REPORTS_BY_SLUG = Object.fromEntries(
  WAREHOUSE_CANNED_REPORTS.map((report) => [report.slug, report]),
);
